package com.macrofocus.eflux.network.logical

import com.macrofocus.eflux.network.physical.BusId
import com.macrofocus.eflux.network.physical.left7

data class LogicalBusId(val name : String) {
    override fun toString(): String = name
}

fun logicalBusIdOf(id: BusId) : LogicalBusId = LogicalBusId(id.left7())